import React from 'react'


const ZoomOut = (props) =>

    <svg xmlns="http://www.w3.org/2000/svg"
         preserveAspectRatio="xMidYMid"
         viewBox="0 0 52.966 52.966"
         {...props}
    >
        <path d="M28.983 20h-14a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2z"/>
        <path d="M51.704 51.273L36.845 35.82c3.79-3.801 6.138-9.041 6.138-14.82 0-11.58-9.42-21-21-21s-21 9.42-21 21 9.42 21 21 21c5.083 0 9.748-1.817 13.384-4.832l14.895 15.491a.998.998 0 0 0 1.414.028 1 1 0 0 0 .028-1.414zM2.983 21c0-10.477 8.523-19 19-19s19 8.523 19 19-8.523 19-19 19-19-8.523-19-19z" fillRule={'evenodd'}/>
    </svg>

export default ZoomOut


// WEBPACK FOOTER //
// ./src/components/_common/_icons/ZoomOut.js